import { Location } from "react-router-dom";

const POST_LOGIN_PATH_KEY = "postLoginPath";

export function pathFromLocation(
  location: Pick<Location, "pathname" | "search" | "hash">,
): string {
  return location.pathname + location.search + location.hash;
}

function currentPath(): string {
  return pathFromLocation(window.location);
}

function isSafeInternalPath(path: string): boolean {
  return path.startsWith("/") && !path.startsWith("//");
}

export function isRootPath(path: string): boolean {
  const pathname = path.split(/[?#]/)[0];
  return pathname === "" || pathname === "/";
}

/** Remember where the user wanted to go before auth completes. */
export function savePostLoginPath(path = currentPath()): void {
  if (isSafeInternalPath(path) && !isRootPath(path)) {
    sessionStorage.setItem(POST_LOGIN_PATH_KEY, path);
  }
}

export function clearPostLoginPath(): void {
  sessionStorage.removeItem(POST_LOGIN_PATH_KEY);
}

/** Returns a saved deep link and clears it, or null if none / invalid. */
export function consumePostLoginPath(): string | null {
  const saved = sessionStorage.getItem(POST_LOGIN_PATH_KEY);
  sessionStorage.removeItem(POST_LOGIN_PATH_KEY);

  if (saved && isSafeInternalPath(saved) && !isRootPath(saved)) {
    return saved;
  }

  return null;
}

export function defaultLandingPath(user: {
  isSuperAdmin: boolean;
  isAdmin: boolean;
}): string {
  return user.isSuperAdmin || user.isAdmin ? "/admin" : "/claim";
}

/** Deep link first; otherwise role landing when allowed and still at root. */
export function resolvePostLoginTarget(
  user: { isSuperAdmin: boolean; isAdmin: boolean },
  pathname: string,
  allowDefaultLanding: boolean,
): string | null {
  const savedPath = consumePostLoginPath();
  if (savedPath) {
    return savedPath;
  }

  if (isRootPath(pathname) && allowDefaultLanding) {
    return defaultLandingPath(user);
  }

  return null;
}
